module.exports = __webpack_public_path__ + "img/product_111.7e0186f.svg";